"use client";

import { useOpenSupportChat } from "@/helpers/useOpenSupportChat";
import { useMessages } from "@/lib/i18n/useMessages";
import { ArrowOutward } from "@mui/icons-material";
import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { SLDialogTerminBuchen } from "../dialogs/SLDialogTerminBuchen";

interface SLButtonGroupChatBuchenProps {
  hasOpenChatButton?: boolean;
  hasBookAppointmentButton?: boolean;
  direction?: "row" | "column";
}

export const SLButtonGroupChatBuchen = ({
  hasOpenChatButton = true,
  hasBookAppointmentButton = true,
  direction,
}: SLButtonGroupChatBuchenProps) => {
  const cta = useMessages().dialogs.contactCta;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
  const { openChat } = useOpenSupportChat();
  const [open, setOpen] = useState(false);

  // Use provided direction or default to mobile-responsive direction
  const buttonDirection = direction || (isMobile ? "column" : "row");

  return (
    <>
      <Stack
        direction={buttonDirection}
        spacing={1}
        sx={{
          justifyContent: "flex-end",
        }}
      >
        {hasOpenChatButton && (
          <Button
            color="success"
            startIcon={<ArrowOutward />}
            onClick={() => {
              openChat();
            }}
          >
            {cta.openChat}
          </Button>
        )}
        {hasBookAppointmentButton && (
          <Button
            variant="contained"
            color="success"
            startIcon={<ArrowOutward />}
            onClick={() => setOpen(true)}
          >
            {cta.freeInitialConsultation}
          </Button>
        )}
      </Stack>
      <SLDialogTerminBuchen open={open} handleClose={() => setOpen(false)} />
    </>
  );
};
